// extracted by mini-css-extract-plugin
export var compact = "_ob-2";
export var phoneFrame = "_ob-0";
export var phoneScreen = "_ob-1";